export default __webpack_public_path__ + "locales/nl/Ldap.json?hash=b7caefd143b62d6efdab46d0dcc9f275";